export function prettyPrintDuration(duration_in_ms)
{
    if ( duration_in_ms == null || duration_in_ms < 1000 ) 
        return 'none';

    let ms_in_seconds = 1000;
    let ms_in_minutes = 60*ms_in_seconds;
    let ms_in_hours = ms_in_minutes*60;
    let ms_in_days = ms_in_hours * 24;

    if ( duration_in_ms % ms_in_days == 0 )
    {
        let days = duration_in_ms / ms_in_days;

        if ( days == 1 ) return "1 day";
        return days+" days";
    }

    if ( duration_in_ms % ms_in_hours == 0)
    {
        let hours = duration_in_ms / ms_in_hours;

        if ( hours == 1 ) return "1 hour";
        return hours+" hours";
    }

    if ( duration_in_ms % ms_in_minutes == 0 )
    {
        let min = duration_in_ms / ms_in_minutes;
        if ( min == 1 ) return "1 minute";
        return min+" minutes";
    }

    let sec = Math.round(duration_in_ms / ms_in_seconds);
    if ( sec == 1 ) return '1 second';
    return sec+" seconds";
}


export function getHumanReadableAge(time, now)
{
    if ( now == null )
        now = new Date().getTime();

    var time_as_date = new Date(time);
    var now_as_date = new Date(now);

    var age_in_ms = now - time;
    var age_in_minutes = age_in_ms / 1000 / 60;
    var age_in_days = age_in_minutes / 60 / 24;

    if ( age_in_minutes < 1 )
        return "now";

    if ( age_in_minutes < 60 )
    {
        return Math.round(age_in_minutes)+" min";
    }

    if ( age_in_days <= 1 && time_as_date.getDate() == now_as_date.getDate() )
    {
       return getPeriodClockTime(time);
    }

    if ( age_in_days < 7 )
    {
        return getShortDayName(time);
    }

    return time_as_date.getDate() + " "+getShortMonthName(time);
}

export function getTimeAndDate(time)
{
    let date_str = getISODate(time);
    let today_str = getISODate(new Date().getTime());

    if ( date_str == today_str )
    {
        return getPeriodClockTime(time);
    }
    
    return getPeriodClockTime(time) + ' ('+getISODate(time)+')';
}

export function getMMDDYYYY(time)
{
    let date = new Date(time);

    let month = date.getMonth()+1;
    let day = date.getDate();
    let year = date.getFullYear();
    
    return month+'/'+day+'/'+year;
}

export function getISODate(time)
{
    let date = new Date(time);

    let month = date.getMonth()+1;
    let day = date.getDate();
    let year = date.getFullYear();

    month = ''+month;
    day = ''+day;
    year = ''+year;

    if ( day.length == 1 ) day = '0'+day;
    if ( month.length == 1 ) month = '0'+month;
    
    return year+'-'+month+'-'+day;
}

export function toISODateString(date)
{
    let month = date.getMonth()+1;
    let day = date.getDate();
    let year = date.getFullYear();

    if ( month < 10 ) month = '0'+month;
    if ( day < 10 ) day = '0'+day;

    return year+'-'+month+'-'+day;
}

export function toISOFirstDayOfMonth(date)
{
    date = new Date(date.getFullYear(), date.getMonth(),1);
    return toISODateString(date);
}

export function toISOLastDayOfMonth(date)
{
    date = new Date(date.getFullYear(), date.getMonth()+1,0);
    return toISODateString(date);
}

export function getPeriodClockTime(time)
{
    const time_as_date = new Date(time);

    var mil_hour = time_as_date.getHours();
    var period = "AM";
    var hour;


    if ( mil_hour < 12 )
    {
        hour = mil_hour;
    }
    else 
    {
        hour = mil_hour - 12;
        period = "PM";
    }

    if ( hour == 0 ) hour = 12;

    var minutes = time_as_date.getMinutes() <= 9 ? '0'+time_as_date.getMinutes() : ''+time_as_date.getMinutes();

    return hour+':'+minutes+' '+period;
}

export function getPeriodClockTimeFromDate(time_as_date)
{
    var mil_hour = time_as_date.getHours();
    var period = "am";
    var hour;


    if ( mil_hour < 12 )
    {
        hour = mil_hour;
    }
    else 
    {
        hour = mil_hour - 12;
        period = "pm";
    }

    if ( hour == 0 ) hour = 12;

    var minutes = time_as_date.getMinutes() <= 9 ? '0'+time_as_date.getMinutes() : ''+time_as_date.getMinutes();

    return hour+':'+minutes+period;
}

export function getShortDayName(time)
{
    const day_of_week = new Date(time).getDay();

    if ( day_of_week == 0 ) return "Sun";
    if ( day_of_week == 1 ) return "Mon";
    if ( day_of_week == 2 ) return "Tue";
    if ( day_of_week == 3 ) return "Wed";
    if ( day_of_week == 4 ) return "Thu";
    if ( day_of_week == 5 ) return "Fri";
    if ( day_of_week == 6 ) return "Sat";

   return "unknown";
}

export function getDayName(time)
{
    const day_of_week = new Date(time).getDay();

    if ( day_of_week == 0 ) return "Sunday";
    if ( day_of_week == 1 ) return "Monday";
    if ( day_of_week == 2 ) return "Tuesday";
    if ( day_of_week == 3 ) return "Wednesday";
    if ( day_of_week == 4 ) return "Thursday";
    if ( day_of_week == 5 ) return "Friday";
    if ( day_of_week == 6 ) return "Saturday";

   return "unknown";
}

export function getShortMonthName(time)
{
    const month = new Date(time).getMonth();

    if ( month == 0 ) return "Jan";
    if ( month == 1 ) return "Feb";
    if ( month == 2 ) return "Mar";
    if ( month == 3 ) return "Apr";
    if ( month == 4 ) return "May";
    if ( month == 5 ) return "Jun";
    if ( month == 6 ) return "Jul";
    if ( month == 7 ) return "Aug";
    if ( month == 8 ) return "Sep";
    if ( month == 9 ) return "Oct";
    if ( month == 10 ) return "Nov";
    if ( month == 11 ) return "Dec";

   return "unknown";
}

export function getHumanReadableTimelineTime(time, now)
{
    if ( now == null )
        now = new Date().getTime();

    var time_as_date = new Date(time);
    var now_as_date = new Date(now);

    var age_in_ms = now - time;
    var age_in_minutes = age_in_ms / 1000 / 60;
    var age_in_days = age_in_minutes / 60 / 24;

    if ( age_in_days <= 1 && time_as_date.getDate() == now_as_date.getDate() )
    {
        return getPeriodClockTime(time);
    }

    if ( age_in_days < 7 )
    {
        return getShortDayName(time)+" - "+getPeriodClockTime(time);
    }

    if ( time_as_date.getFullYear() == now_as_date.getFullYear() )
        return time_as_date.getDate() + " "+getShortMonthName(time);

    return time_as_date.getDate() + " "+getShortMonthName(time)+" "+time_as_date.getFullYear();
}

export function getLongTimestamp(time, now)
{
    if ( now == null )
        now = new Date().getTime();

    var time_as_date = new Date(time);
    var now_as_date = new Date(now);

    var age_in_ms = now - time;
    var age_in_minutes = age_in_ms / 1000 / 60;
    var age_in_days = age_in_minutes / 60 / 24;

    if ( time_as_date.getFullYear() != now_as_date.getFullYear() )
    {
        return getShortDayName(time)+", "+getShortMonthName(time)+" "+time_as_date.getDate()+" "+time_as_date.getFullYear()+" @ "+getPeriodClockTime(time);
    }

    return getShortDayName(time)+", "+getShortMonthName(time)+" "+time_as_date.getDate()+" @ "+getPeriodClockTime(time);
}

export function getHumanReadableDuration(time)
{
    function label(qty, single, plural)
    {
        return qty == 1 ? single : plural;
    }

    if ( time < 1000 )
    {
        return "Less than one second";
    }

    if ( time < 60000 )
    {
        let seconds = Math.floor(time/1000);
        return seconds + " "+label(seconds, "second", "seconds");
    }

    if ( time < 3600000 )
    {
        let minutes = Math.floor(time/60000);
        return minutes + " "+label(minutes, "minute", "minutes");
    }

    let hours = Math.floor(time/3600000);
    let minutes = Math.floor((time - hours*3600000)/60000);

    if ( minutes == 0 )
        return hours+" "+label(hours,"hour","hours");

    return hours + " "+label(hours,"hour","hours")+", "+minutes+" "+label(minutes,"minute","minutes");
}

export function getDurationAsMilliseconds(duration)
{
    if ( typeof duration != 'string' ) return duration;

    duration = duration.toLowerCase();

    let value = parseInt(duration);

    if ( Number.isNaN(value) ) 
        return null;

    if ( duration.includes('year') || duration.includes('yr') )
    {
        return value * 365 * 24 * 60 * 60 * 1000;
    }

    if ( duration.includes('day') )
    {
        return value * 24 * 60 * 60 * 1000;
    }

    if ( duration.includes('hour') || duration.includes('hr') )
    {
        return value * 60 * 60 * 1000;
    }

    if ( duration.includes('min') )
    {
        return value * 60 * 1000;
    }

    if ( duration.includes('sec') )
    {
        return value * 1000;
    }

    return value;
}

export function wallTimePrettyPrintUs(wall_time)
{
    let parts = wall_time.split(':', 2);

    let hour = parseInt(parts[0]);

    if ( hour > 12 )
    {
        hour = hour - 12;
        return hour+':'+parts[1]+' PM';
    }
    else if ( hour == 12 )
    {
        return hour+':'+parts[1]+' PM';
    }
    else if ( hour == 0 )
    {
        return '12:'+parts[1]+' AM';
    }
    else
    {
        return hour+':'+parts[1]+' AM';
    }
}

export default {
     getHumanReadableAge,
     getPeriodClockTime,
     getHumanReadableTimelineTime,
     getMMDDYYYY,
     getHumanReadableDuration,
     getTimeAndDate,
     toISODateString,
     toISOFirstDayOfMonth,
     toISOLastDayOfMonth,
     prettyPrintDuration,
     getLongTimestamp,
     getDurationAsMilliseconds,
     wallTimePrettyPrintUs
};